var React = require('react');

function Missile (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".cls-1{fill:none;stroke:#000;stroke-linecap:square;stroke-linejoin:bevel;stroke-width:2px;}")),React.createElement("title",{"key":1},"Missile Battery"),React.createElement("g",{"id":"layer1","key":2},React.createElement("g",{"id":"g1611"},[React.createElement("path",{"id":"path4015-1","className":"cls-1","d":"M59,34H19L9,44V84L19,94H59L69,84V44Z","key":0}),React.createElement("path",{"id":"path4017-9","className":"cls-1","d":"M89,44h20","key":1}),React.createElement("path",{"id":"path4019-4","className":"cls-1","d":"M89,84h20","key":2}),React.createElement("path",{"id":"path4019-4-0","className":"cls-1","d":"M99,64h20","key":3})]))]);
}

Missile.defaultProps = {"id":"svg8","viewBox":"0 0 128 128"};

module.exports = Missile;

Missile.default = Missile;
